export default{

  setRole(state,val){
  	// console.log(val);
    state.role = val.role;
    state.permissionLevel = val.level;
  },
  setUsername(state,val){
    state.username = val.username;
  } 
}


// WEBPACK FOOTER //
// ./src/store/mutations.js